import { ContactModelProps } from "common";
import { useAuth } from "hooks";
import { ILoginResponse, ISignUpResponse } from "hooks/auth/types";
import { useApolloAuth } from "providers/apollo_auth";
import { ForgetPasswordProps, ResetPasswordProps } from "site/ui";
import { IAdminRole, IUser } from "utils/types"
import { useUserFlow } from "./useUserFlow";
import { useNotification } from "providers";

// interface ILoginResponse {accessToken: string; userId: string;}
export const useGeneralFlow = (): 
Pick<ResetPasswordProps, "onResetPassword"> & 
Pick<ForgetPasswordProps, "onSendOtp"|"onVerifyOtp"> & 
Pick<ContactModelProps, "onCreateContactMessage"> & {
    onSignUp: (user: Partial<IUser>, password: string, accessToken: string) => Promise<ISignUpResponse|undefined>
    createAdminUser: (user: Partial<IUser>, password: string, adminRole: IAdminRole) => Promise<IUser|undefined>
    onLogin: (data: {email: string; password: string; isAdmin?: boolean}) => Promise<ILoginResponse|undefined>;
} => {
    const authHook = useAuth();
    const apolloAuthHook = useApolloAuth()
    const flow = useUserFlow()
    const { success } = useNotification();
    return {
        async onVerifyOtp(email, otp) {
            const accessToken = await authHook.verifyToken({
                token: otp,
                email,
            });
            if(accessToken){
                success({
                    message: "OTP verified successfully!"
                })
            }
            return accessToken;
        },
        async onSendOtp(email) {
            const res = await authHook.sendOTP({
                email,
                phone: ""
            })
            if(res?.success){
                success({
                    message: "OTP sent successfully!"
                })
            }
            
            return res?.success || false;
        },
        async createAdminUser(user, password, adminRole) {
            const response = await authHook.singUp({user, password, adminRole})
            const res = await flow.onGetUser(response?.userId!)
            if(res){
                success({
                    message: "Admin user created successfully!"
                })
            }
            return res
        },
        async onSignUp(user, password, accessToken) {
            const response = await authHook.singUp({user, password, accessToken})
            if(response){
                const { accessToken, userId } = response
                if(!accessToken || !userId) throw new Error('Invalid response')
                apolloAuthHook.login(accessToken, userId)
            }
            return response
        },
        async onResetPassword(data) {
            const res = await authHook.resetPassword({
                email: data.email,
                password: data.password,
            }, data.token)
            if(res){
                success({
                    message: "Password reset successfully!"
                })
            }
            return res || false;
        },
        async onLogin(data) {            
            const response = await authHook.login({
                email: data.email,
                password: data.password,
                isAdmin: data.isAdmin,
                phone: ""
            })
            if(response){
                const { accessToken, userId } = response
                if(!accessToken || !userId) throw new Error('Invalid response')
                apolloAuthHook.login(accessToken, userId)
            }
            return response;
        },
        async onCreateContactMessage(contactInfo) {
            return true
        },
    }
}